module.exports = __webpack_public_path__ + "img/vol05_cup02_badge.38fc5cf6.png";